module.exports = __webpack_public_path__ + "images/screen-shots/parent_communication-5635133609bd80fc116f3509946dddbd.png";